import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w100",
  style: `height: 50px; text-align: middle; border-bottom: 1px solid #ddd;`
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "w100 fw600" }, "URL・フォームなど", -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "w100 fw600" }, "日程の詳細", -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "w100 fw600" }, "スグINボタン設定", -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (!_ctx.isSP && _ctx.selectedTabName)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(`${_ctx.showInstantRoomTab ? `w33` : `w50`} roomsCategoryTab pointer centered fl pad10 ${
                _ctx.selectedTabName == 'public' ? 'selected fw600' : ''
            }`),
          style: {"line-height":"30px"},
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectTab('public')))
        }, _hoisted_3, 2),
        _createElementVNode("div", {
          class: _normalizeClass(`${_ctx.showInstantRoomTab ? `w33` : `w50`} roomsCategoryTab pointer centered fl pad10 ${
                _ctx.selectedTabName == 'schedule' ? 'selected fw600' : ''
            }`),
          style: {"line-height":"30px"},
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectTab('schedule')))
        }, _hoisted_5, 2),
        (_ctx.showInstantRoomTab)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(`w33 roomsCategoryTab pointer centered fl pad10 ${_ctx.selectedTabName == 'instant_room' ? 'selected fw600' : ''}`),
              style: {"line-height":"30px"},
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectTab('instant_room')))
            }, _hoisted_7, 2))
          : _createCommentVNode("", true),
        _hoisted_8
      ]))
    : _createCommentVNode("", true)
}